import {setConfig} from 'react-hot-loader';
import {hot} from 'react-hot-loader/root';
import {withRouter} from 'react-router-dom';
import '~/css/App';
import Routes from './Routes';

setConfig({showReactDomPatchNotification: false});
export default hot(withRouter(Routes));
